module.exports={
 "paths": {
  "/iati-activities": {
   "orderby": 1,
   "type": "null"
  },
  "/iati-activities/iati-activity": {
   "multiple": true,
   "orderby": 5,
   "required": true,
   "type": "null"
  },
  "/iati-activities/iati-activity/activity-date": {
   "multiple": true,
   "orderby": 44,
   "required": true,
   "type": "null"
  },
  "/iati-activities/iati-activity/activity-date/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/activity-date",
    "/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 47,
   "type": "text"
  },
  "/iati-activities/iati-activity/activity-date/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/activity-date",
    "/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/activity-date@iso-date": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/activity-date",
    "@iso-date"
   ],
   "orderby": 46,
   "required": true,
   "type": "date"
  },
  "/iati-activities/iati-activity/activity-date@type": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/activity-date",
    "@type"
   ],
   "orderby": 45,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/activity-scope": {
   "orderby": 69,
   "type": "null"
  },
  "/iati-activities/iati-activity/activity-scope@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/activity-scope@code"
   ],
   "orderby": 70,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/activity-status": {
   "orderby": 42,
   "required": true,
   "type": "null"
  },
  "/iati-activities/iati-activity/activity-status@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/activity-status@code"
   ],
   "orderby": 43,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/budget": {
   "multiple": true,
   "orderby": 158,
   "type": "null"
  },
  "/iati-activities/iati-activity/budget/period-end": {
   "orderby": 163,
   "required": true,
   "type": "null"
  },
  "/iati-activities/iati-activity/budget/period-end@iso-date": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/budget",
    "/period-end@iso-date"
   ],
   "orderby": 164,
   "required": true,
   "type": "date"
  },
  "/iati-activities/iati-activity/budget/period-start": {
   "orderby": 161,
   "required": true,
   "type": "null"
  },
  "/iati-activities/iati-activity/budget/period-start@iso-date": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/budget",
    "/period-start@iso-date"
   ],
   "orderby": 162,
   "required": true,
   "type": "date"
  },
  "/iati-activities/iati-activity/budget/value": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/budget",
    "/value"
   ],
   "orderby": 165,
   "required": true,
   "type": "number"
  },
  "/iati-activities/iati-activity/budget/value@currency": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/budget",
    "/value@currency"
   ],
   "orderby": 442,
   "type": "text"
  },
  "/iati-activities/iati-activity/budget/value@value-date": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/budget",
    "/value@value-date"
   ],
   "orderby": 443,
   "type": "date"
  },
  "/iati-activities/iati-activity/budget@status": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/budget",
    "@status"
   ],
   "orderby": 160,
   "type": "text"
  },
  "/iati-activities/iati-activity/budget@type": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/budget",
    "@type"
   ],
   "orderby": 159,
   "type": "text"
  },
  "/iati-activities/iati-activity/capital-spend": {
   "orderby": 189,
   "type": "null"
  },
  "/iati-activities/iati-activity/capital-spend@percentage": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/capital-spend@percentage"
   ],
   "orderby": 190,
   "required": true,
   "type": "number"
  },
  "/iati-activities/iati-activity/collaboration-type": {
   "orderby": 147,
   "type": "null"
  },
  "/iati-activities/iati-activity/collaboration-type@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/collaboration-type@code"
   ],
   "orderby": 148,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/conditions": {
   "orderby": 265,
   "type": "null"
  },
  "/iati-activities/iati-activity/conditions/condition": {
   "multiple": true,
   "orderby": 267,
   "type": "null"
  },
  "/iati-activities/iati-activity/conditions/condition/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/conditions/condition",
    "/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 269,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/conditions/condition/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/conditions/condition",
    "/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/conditions/condition@type": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/conditions/condition",
    "@type"
   ],
   "orderby": 268,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/conditions@attached": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/conditions@attached"
   ],
   "orderby": 266,
   "required": true,
   "type": "bool"
  },
  "/iati-activities/iati-activity/contact-info": {
   "multiple": true,
   "orderby": 49,
   "type": "null"
  },
  "/iati-activities/iati-activity/contact-info/department": {
   "orderby": 54,
   "type": "null"
  },
  "/iati-activities/iati-activity/contact-info/department/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/contact-info",
    "/department/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 55,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/contact-info/department/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/contact-info",
    "/department/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/contact-info/email": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/contact-info",
    "/email",
    ""
   ],
   "multiple": true,
   "orderby": 64,
   "type": "text"
  },
  "/iati-activities/iati-activity/contact-info/job-title": {
   "orderby": 60,
   "type": "null"
  },
  "/iati-activities/iati-activity/contact-info/job-title/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/contact-info",
    "/job-title/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 61,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/contact-info/job-title/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/contact-info",
    "/job-title/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/contact-info/mailing-address": {
   "multiple": true,
   "orderby": 66,
   "type": "null"
  },
  "/iati-activities/iati-activity/contact-info/mailing-address/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/contact-info",
    "/mailing-address",
    "/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 67,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/contact-info/mailing-address/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/contact-info",
    "/mailing-address",
    "/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/contact-info/organisation": {
   "orderby": 51,
   "type": "null"
  },
  "/iati-activities/iati-activity/contact-info/organisation/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/contact-info",
    "/organisation/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 52,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/contact-info/organisation/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/contact-info",
    "/organisation/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/contact-info/person-name": {
   "orderby": 57,
   "type": "null"
  },
  "/iati-activities/iati-activity/contact-info/person-name/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/contact-info",
    "/person-name/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 58,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/contact-info/person-name/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/contact-info",
    "/person-name/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/contact-info/telephone": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/contact-info",
    "/telephone",
    ""
   ],
   "multiple": true,
   "orderby": 63,
   "type": "text"
  },
  "/iati-activities/iati-activity/contact-info/website": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/contact-info",
    "/website",
    ""
   ],
   "multiple": true,
   "orderby": 65,
   "type": "text"
  },
  "/iati-activities/iati-activity/contact-info@type": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/contact-info",
    "@type"
   ],
   "orderby": 50,
   "type": "text"
  },
  "/iati-activities/iati-activity/country-budget-items": {
   "orderby": 125,
   "type": "null"
  },
  "/iati-activities/iati-activity/country-budget-items/budget-item": {
   "multiple": true,
   "orderby": 127,
   "required": true,
   "type": "null"
  },
  "/iati-activities/iati-activity/country-budget-items/budget-item/description": {
   "orderby": 130,
   "type": "null"
  },
  "/iati-activities/iati-activity/country-budget-items/budget-item/description/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/country-budget-items/budget-item",
    "/description/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 131,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/country-budget-items/budget-item/description/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/country-budget-items/budget-item",
    "/description/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/country-budget-items/budget-item@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/country-budget-items/budget-item",
    "@code"
   ],
   "orderby": 128,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/country-budget-items/budget-item@percentage": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/country-budget-items/budget-item",
    "@percentage"
   ],
   "orderby": 129,
   "type": "number"
  },
  "/iati-activities/iati-activity/country-budget-items@vocabulary": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/country-budget-items@vocabulary"
   ],
   "orderby": 126,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/crs-add": {
   "orderby": 410,
   "type": "null"
  },
  "/iati-activities/iati-activity/crs-add/channel-code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/crs-add/channel-code"
   ],
   "orderby": 435,
   "type": "text"
  },
  "/iati-activities/iati-activity/crs-add/loan-status": {
   "orderby": 427,
   "type": "null"
  },
  "/iati-activities/iati-activity/crs-add/loan-status/interest-arrears": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/crs-add/loan-status/interest-arrears"
   ],
   "orderby": 434,
   "type": "number"
  },
  "/iati-activities/iati-activity/crs-add/loan-status/interest-received": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/crs-add/loan-status/interest-received"
   ],
   "orderby": 431,
   "type": "number"
  },
  "/iati-activities/iati-activity/crs-add/loan-status/principal-arrears": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/crs-add/loan-status/principal-arrears"
   ],
   "orderby": 433,
   "type": "number"
  },
  "/iati-activities/iati-activity/crs-add/loan-status/principal-outstanding": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/crs-add/loan-status/principal-outstanding"
   ],
   "orderby": 432,
   "type": "number"
  },
  "/iati-activities/iati-activity/crs-add/loan-status@currency": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/crs-add/loan-status@currency"
   ],
   "orderby": 442,
   "type": "text"
  },
  "/iati-activities/iati-activity/crs-add/loan-status@value-date": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/crs-add/loan-status@value-date"
   ],
   "orderby": 443,
   "type": "date"
  },
  "/iati-activities/iati-activity/crs-add/loan-status@year": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/crs-add/loan-status@year"
   ],
   "orderby": 428,
   "required": true,
   "type": "number"
  },
  "/iati-activities/iati-activity/crs-add/loan-terms": {
   "orderby": 414,
   "type": "null"
  },
  "/iati-activities/iati-activity/crs-add/loan-terms/commitment-date": {
   "orderby": 421,
   "type": "null"
  },
  "/iati-activities/iati-activity/crs-add/loan-terms/commitment-date@iso-date": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/crs-add/loan-terms/commitment-date@iso-date"
   ],
   "orderby": 422,
   "required": true,
   "type": "date"
  },
  "/iati-activities/iati-activity/crs-add/loan-terms/repayment-final-date": {
   "orderby": 425,
   "type": "null"
  },
  "/iati-activities/iati-activity/crs-add/loan-terms/repayment-final-date@iso-date": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/crs-add/loan-terms/repayment-final-date@iso-date"
   ],
   "orderby": 426,
   "required": true,
   "type": "date"
  },
  "/iati-activities/iati-activity/crs-add/loan-terms/repayment-first-date": {
   "orderby": 423,
   "type": "null"
  },
  "/iati-activities/iati-activity/crs-add/loan-terms/repayment-first-date@iso-date": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/crs-add/loan-terms/repayment-first-date@iso-date"
   ],
   "orderby": 424,
   "required": true,
   "type": "date"
  },
  "/iati-activities/iati-activity/crs-add/loan-terms/repayment-plan": {
   "orderby": 419,
   "type": "null"
  },
  "/iati-activities/iati-activity/crs-add/loan-terms/repayment-plan@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/crs-add/loan-terms/repayment-plan@code"
   ],
   "orderby": 420,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/crs-add/loan-terms/repayment-type": {
   "orderby": 417,
   "type": "null"
  },
  "/iati-activities/iati-activity/crs-add/loan-terms/repayment-type@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/crs-add/loan-terms/repayment-type@code"
   ],
   "orderby": 418,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/crs-add/loan-terms@rate-1": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/crs-add/loan-terms@rate-1"
   ],
   "orderby": 415,
   "type": "number"
  },
  "/iati-activities/iati-activity/crs-add/loan-terms@rate-2": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/crs-add/loan-terms@rate-2"
   ],
   "orderby": 416,
   "type": "number"
  },
  "/iati-activities/iati-activity/crs-add/other-flags": {
   "multiple": true,
   "orderby": 411,
   "type": "null"
  },
  "/iati-activities/iati-activity/crs-add/other-flags@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/crs-add/other-flags",
    "@code"
   ],
   "orderby": 412,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/crs-add/other-flags@significance": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/crs-add/other-flags",
    "@significance"
   ],
   "orderby": 413,
   "required": true,
   "type": "bool"
  },
  "/iati-activities/iati-activity/default-aid-type": {
   "multiple": true,
   "orderby": 153,
   "type": "null"
  },
  "/iati-activities/iati-activity/default-aid-type@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/default-aid-type",
    "@code"
   ],
   "orderby": 239,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/default-aid-type@vocabulary": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/default-aid-type",
    "@vocabulary"
   ],
   "orderby": 240,
   "type": "text"
  },
  "/iati-activities/iati-activity/default-finance-type": {
   "orderby": 151,
   "type": "null"
  },
  "/iati-activities/iati-activity/default-finance-type@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/default-finance-type@code"
   ],
   "orderby": 152,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/default-flow-type": {
   "orderby": 149,
   "type": "null"
  },
  "/iati-activities/iati-activity/default-flow-type@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/default-flow-type@code"
   ],
   "orderby": 150,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/default-tied-status": {
   "orderby": 156,
   "type": "null"
  },
  "/iati-activities/iati-activity/default-tied-status@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/default-tied-status@code"
   ],
   "orderby": 157,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/description": {
   "multiple": true,
   "orderby": 23,
   "required": true,
   "type": "null"
  },
  "/iati-activities/iati-activity/description/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/description",
    "/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 25,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/description/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/description",
    "/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/description@type": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/description",
    "@type"
   ],
   "orderby": 24,
   "type": "text"
  },
  "/iati-activities/iati-activity/document-link": {
   "multiple": true,
   "orderby": 243,
   "type": "null"
  },
  "/iati-activities/iati-activity/document-link/category": {
   "multiple": true,
   "orderby": 404,
   "required": true,
   "type": "null"
  },
  "/iati-activities/iati-activity/document-link/category@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/document-link",
    "/category",
    "@code"
   ],
   "orderby": 405,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/document-link/description": {
   "orderby": 249,
   "type": "null"
  },
  "/iati-activities/iati-activity/document-link/description/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/document-link",
    "/description/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 250,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/document-link/description/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/document-link",
    "/description/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/document-link/document-date": {
   "orderby": 408,
   "type": "null"
  },
  "/iati-activities/iati-activity/document-link/document-date@iso-date": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/document-link",
    "/document-date@iso-date"
   ],
   "orderby": 409,
   "required": true,
   "type": "date"
  },
  "/iati-activities/iati-activity/document-link/language": {
   "multiple": true,
   "orderby": 406,
   "type": "null"
  },
  "/iati-activities/iati-activity/document-link/language@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/document-link",
    "/language",
    "@code"
   ],
   "orderby": 407,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/document-link/title": {
   "orderby": 246,
   "required": true,
   "type": "null"
  },
  "/iati-activities/iati-activity/document-link/title/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/document-link",
    "/title/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 247,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/document-link/title/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/document-link",
    "/title/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/document-link@format": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/document-link",
    "@format"
   ],
   "orderby": 397,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/document-link@url": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/document-link",
    "@url"
   ],
   "orderby": 396,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/fss": {
   "orderby": 436,
   "type": "null"
  },
  "/iati-activities/iati-activity/fss/forecast": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/fss/forecast",
    ""
   ],
   "multiple": true,
   "orderby": 440,
   "type": "number"
  },
  "/iati-activities/iati-activity/fss/forecast@currency": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/fss/forecast",
    "@currency"
   ],
   "orderby": 442,
   "type": "text"
  },
  "/iati-activities/iati-activity/fss/forecast@value-date": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/fss/forecast",
    "@value-date"
   ],
   "orderby": 443,
   "type": "date"
  },
  "/iati-activities/iati-activity/fss/forecast@year": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/fss/forecast",
    "@year"
   ],
   "orderby": 441,
   "required": true,
   "type": "number"
  },
  "/iati-activities/iati-activity/fss@extraction-date": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/fss@extraction-date"
   ],
   "orderby": 437,
   "required": true,
   "type": "date"
  },
  "/iati-activities/iati-activity/fss@phaseout-year": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/fss@phaseout-year"
   ],
   "orderby": 439,
   "type": "number"
  },
  "/iati-activities/iati-activity/fss@priority": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/fss@priority"
   ],
   "orderby": 438,
   "type": "bool"
  },
  "/iati-activities/iati-activity/humanitarian-scope": {
   "multiple": true,
   "orderby": 133,
   "type": "null"
  },
  "/iati-activities/iati-activity/humanitarian-scope/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/humanitarian-scope",
    "/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 138,
   "type": "text"
  },
  "/iati-activities/iati-activity/humanitarian-scope/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/humanitarian-scope",
    "/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/humanitarian-scope@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/humanitarian-scope",
    "@code"
   ],
   "orderby": 137,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/humanitarian-scope@type": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/humanitarian-scope",
    "@type"
   ],
   "orderby": 134,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/humanitarian-scope@vocabulary": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/humanitarian-scope",
    "@vocabulary"
   ],
   "orderby": 135,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/humanitarian-scope@vocabulary-uri": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/humanitarian-scope",
    "@vocabulary-uri"
   ],
   "orderby": 136,
   "type": "text"
  },
  "/iati-activities/iati-activity/iati-identifier": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/iati-identifier"
   ],
   "orderby": 13,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/legacy-data": {
   "multiple": true,
   "orderby": 261,
   "type": "null"
  },
  "/iati-activities/iati-activity/legacy-data@iati-equivalent": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/legacy-data",
    "@iati-equivalent"
   ],
   "orderby": 264,
   "type": "text"
  },
  "/iati-activities/iati-activity/legacy-data@name": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/legacy-data",
    "@name"
   ],
   "orderby": 262,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/legacy-data@value": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/legacy-data",
    "@value"
   ],
   "orderby": 263,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/location": {
   "multiple": true,
   "orderby": 83,
   "type": "null"
  },
  "/iati-activities/iati-activity/location/activity-description": {
   "orderby": 96,
   "type": "null"
  },
  "/iati-activities/iati-activity/location/activity-description/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/location",
    "/activity-description/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 97,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/location/activity-description/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/location",
    "/activity-description/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/location/administrative": {
   "multiple": true,
   "orderby": 99,
   "type": "null"
  },
  "/iati-activities/iati-activity/location/administrative@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/location",
    "/administrative",
    "@code"
   ],
   "orderby": 100,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/location/administrative@level": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/location",
    "/administrative",
    "@level"
   ],
   "orderby": 102,
   "type": "uint"
  },
  "/iati-activities/iati-activity/location/administrative@vocabulary": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/location",
    "/administrative",
    "@vocabulary"
   ],
   "orderby": 101,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/location/description": {
   "orderby": 93,
   "type": "null"
  },
  "/iati-activities/iati-activity/location/description/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/location",
    "/description/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 94,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/location/description/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/location",
    "/description/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/location/exactness": {
   "orderby": 106,
   "type": "null"
  },
  "/iati-activities/iati-activity/location/exactness@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/location",
    "/exactness@code"
   ],
   "orderby": 107,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/location/feature-designation": {
   "orderby": 110,
   "type": "null"
  },
  "/iati-activities/iati-activity/location/feature-designation@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/location",
    "/feature-designation@code"
   ],
   "orderby": 111,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/location/location-class": {
   "orderby": 108,
   "type": "null"
  },
  "/iati-activities/iati-activity/location/location-class@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/location",
    "/location-class@code"
   ],
   "orderby": 109,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/location/location-id": {
   "multiple": true,
   "orderby": 87,
   "type": "null"
  },
  "/iati-activities/iati-activity/location/location-id@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/location",
    "/location-id",
    "@code"
   ],
   "orderby": 88,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/location/location-id@vocabulary": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/location",
    "/location-id",
    "@vocabulary"
   ],
   "orderby": 89,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/location/location-reach": {
   "orderby": 85,
   "type": "null"
  },
  "/iati-activities/iati-activity/location/location-reach@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/location",
    "/location-reach@code"
   ],
   "orderby": 86,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/location/name": {
   "orderby": 90,
   "type": "null"
  },
  "/iati-activities/iati-activity/location/name/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/location",
    "/name/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 91,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/location/name/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/location",
    "/name/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/location/point": {
   "orderby": 103,
   "type": "null"
  },
  "/iati-activities/iati-activity/location/point/pos": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/location",
    "/point/pos"
   ],
   "orderby": 105,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/location/point@srsName": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/location",
    "/point@srsName"
   ],
   "orderby": 104,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/location@ref": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/location",
    "@ref"
   ],
   "orderby": 84,
   "type": "text"
  },
  "/iati-activities/iati-activity/other-identifier": {
   "multiple": true,
   "orderby": 35,
   "type": "null"
  },
  "/iati-activities/iati-activity/other-identifier/owner-org": {
   "orderby": 38,
   "type": "null"
  },
  "/iati-activities/iati-activity/other-identifier/owner-org/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/other-identifier",
    "/owner-org/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 40,
   "type": "text"
  },
  "/iati-activities/iati-activity/other-identifier/owner-org/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/other-identifier",
    "/owner-org/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/other-identifier/owner-org@ref": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/other-identifier",
    "/owner-org@ref"
   ],
   "orderby": 39,
   "type": "text"
  },
  "/iati-activities/iati-activity/other-identifier@ref": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/other-identifier",
    "@ref"
   ],
   "orderby": 36,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/other-identifier@type": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/other-identifier",
    "@type"
   ],
   "orderby": 37,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/participating-org": {
   "multiple": true,
   "orderby": 27,
   "required": true,
   "type": "null"
  },
  "/iati-activities/iati-activity/participating-org/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/participating-org",
    "/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 33,
   "type": "text"
  },
  "/iati-activities/iati-activity/participating-org/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/participating-org",
    "/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/participating-org@activity-id": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/participating-org",
    "@activity-id"
   ],
   "orderby": 31,
   "type": "text"
  },
  "/iati-activities/iati-activity/participating-org@crs-channel-code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/participating-org",
    "@crs-channel-code"
   ],
   "orderby": 32,
   "type": "text"
  },
  "/iati-activities/iati-activity/participating-org@ref": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/participating-org",
    "@ref"
   ],
   "orderby": 28,
   "type": "text"
  },
  "/iati-activities/iati-activity/participating-org@role": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/participating-org",
    "@role"
   ],
   "orderby": 30,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/participating-org@type": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/participating-org",
    "@type"
   ],
   "orderby": 29,
   "type": "text"
  },
  "/iati-activities/iati-activity/planned-disbursement": {
   "multiple": true,
   "orderby": 168,
   "type": "null"
  },
  "/iati-activities/iati-activity/planned-disbursement/period-end": {
   "orderby": 172,
   "type": "null"
  },
  "/iati-activities/iati-activity/planned-disbursement/period-end@iso-date": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/planned-disbursement",
    "/period-end@iso-date"
   ],
   "orderby": 173,
   "required": true,
   "type": "date"
  },
  "/iati-activities/iati-activity/planned-disbursement/period-start": {
   "orderby": 170,
   "required": true,
   "type": "null"
  },
  "/iati-activities/iati-activity/planned-disbursement/period-start@iso-date": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/planned-disbursement",
    "/period-start@iso-date"
   ],
   "orderby": 171,
   "required": true,
   "type": "date"
  },
  "/iati-activities/iati-activity/planned-disbursement/provider-org": {
   "orderby": 177,
   "type": "null"
  },
  "/iati-activities/iati-activity/planned-disbursement/provider-org/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/planned-disbursement",
    "/provider-org/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 181,
   "type": "text"
  },
  "/iati-activities/iati-activity/planned-disbursement/provider-org/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/planned-disbursement",
    "/provider-org/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/planned-disbursement/provider-org@provider-activity-id": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/planned-disbursement",
    "/provider-org@provider-activity-id"
   ],
   "orderby": 179,
   "type": "text"
  },
  "/iati-activities/iati-activity/planned-disbursement/provider-org@ref": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/planned-disbursement",
    "/provider-org@ref"
   ],
   "orderby": 178,
   "type": "text"
  },
  "/iati-activities/iati-activity/planned-disbursement/provider-org@type": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/planned-disbursement",
    "/provider-org@type"
   ],
   "orderby": 180,
   "type": "text"
  },
  "/iati-activities/iati-activity/planned-disbursement/receiver-org": {
   "orderby": 183,
   "type": "null"
  },
  "/iati-activities/iati-activity/planned-disbursement/receiver-org/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/planned-disbursement",
    "/receiver-org/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 187,
   "type": "text"
  },
  "/iati-activities/iati-activity/planned-disbursement/receiver-org/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/planned-disbursement",
    "/receiver-org/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/planned-disbursement/receiver-org@receiver-activity-id": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/planned-disbursement",
    "/receiver-org@receiver-activity-id"
   ],
   "orderby": 185,
   "type": "text"
  },
  "/iati-activities/iati-activity/planned-disbursement/receiver-org@ref": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/planned-disbursement",
    "/receiver-org@ref"
   ],
   "orderby": 184,
   "type": "text"
  },
  "/iati-activities/iati-activity/planned-disbursement/receiver-org@type": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/planned-disbursement",
    "/receiver-org@type"
   ],
   "orderby": 186,
   "type": "text"
  },
  "/iati-activities/iati-activity/planned-disbursement/value": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/planned-disbursement",
    "/value"
   ],
   "orderby": 174,
   "required": true,
   "type": "number"
  },
  "/iati-activities/iati-activity/planned-disbursement/value@currency": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/planned-disbursement",
    "/value@currency"
   ],
   "orderby": 442,
   "type": "text"
  },
  "/iati-activities/iati-activity/planned-disbursement/value@value-date": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/planned-disbursement",
    "/value@value-date"
   ],
   "orderby": 443,
   "type": "date"
  },
  "/iati-activities/iati-activity/planned-disbursement@type": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/planned-disbursement",
    "@type"
   ],
   "orderby": 169,
   "type": "text"
  },
  "/iati-activities/iati-activity/policy-marker": {
   "multiple": true,
   "orderby": 140,
   "type": "null"
  },
  "/iati-activities/iati-activity/policy-marker/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/policy-marker",
    "/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 145,
   "type": "text"
  },
  "/iati-activities/iati-activity/policy-marker/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/policy-marker",
    "/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/policy-marker@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/policy-marker",
    "@code"
   ],
   "orderby": 143,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/policy-marker@significance": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/policy-marker",
    "@significance"
   ],
   "orderby": 144,
   "type": "text"
  },
  "/iati-activities/iati-activity/policy-marker@vocabulary": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/policy-marker",
    "@vocabulary"
   ],
   "orderby": 141,
   "type": "text"
  },
  "/iati-activities/iati-activity/policy-marker@vocabulary-uri": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/policy-marker",
    "@vocabulary-uri"
   ],
   "orderby": 142,
   "type": "text"
  },
  "/iati-activities/iati-activity/recipient-country": {
   "multiple": true,
   "orderby": 71,
   "type": "null"
  },
  "/iati-activities/iati-activity/recipient-country/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/recipient-country",
    "/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 74,
   "type": "text"
  },
  "/iati-activities/iati-activity/recipient-country/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/recipient-country",
    "/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/recipient-country@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/recipient-country",
    "@code"
   ],
   "orderby": 72,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/recipient-country@percentage": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/recipient-country",
    "@percentage"
   ],
   "orderby": 73,
   "type": "number"
  },
  "/iati-activities/iati-activity/recipient-region": {
   "multiple": true,
   "orderby": 76,
   "type": "null"
  },
  "/iati-activities/iati-activity/recipient-region/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/recipient-region",
    "/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 81,
   "type": "text"
  },
  "/iati-activities/iati-activity/recipient-region/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/recipient-region",
    "/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/recipient-region@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/recipient-region",
    "@code"
   ],
   "orderby": 77,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/recipient-region@percentage": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/recipient-region",
    "@percentage"
   ],
   "orderby": 80,
   "type": "number"
  },
  "/iati-activities/iati-activity/recipient-region@vocabulary": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/recipient-region",
    "@vocabulary"
   ],
   "orderby": 78,
   "type": "text"
  },
  "/iati-activities/iati-activity/recipient-region@vocabulary-uri": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/recipient-region",
    "@vocabulary-uri"
   ],
   "orderby": 79,
   "type": "text"
  },
  "/iati-activities/iati-activity/related-activity": {
   "multiple": true,
   "orderby": 258,
   "type": "null"
  },
  "/iati-activities/iati-activity/related-activity@ref": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/related-activity",
    "@ref"
   ],
   "orderby": 259,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/related-activity@type": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/related-activity",
    "@type"
   ],
   "orderby": 260,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/reporting-org": {
   "orderby": 14,
   "required": true,
   "type": "null"
  },
  "/iati-activities/iati-activity/reporting-org/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/reporting-org/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 18,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/reporting-org/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/reporting-org/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/reporting-org@ref": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/reporting-org@ref"
   ],
   "orderby": 15,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/reporting-org@secondary-reporter": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/reporting-org@secondary-reporter"
   ],
   "orderby": 17,
   "type": "bool"
  },
  "/iati-activities/iati-activity/reporting-org@type": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/reporting-org@type"
   ],
   "orderby": 16,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result": {
   "multiple": true,
   "orderby": 271,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/description": {
   "orderby": 277,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/description/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/description/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 278,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/description/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/description/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/document-link": {
   "multiple": true,
   "orderby": 280,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/document-link/category": {
   "multiple": true,
   "orderby": 404,
   "required": true,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/document-link/category@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/document-link",
    "/category",
    "@code"
   ],
   "orderby": 405,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/document-link/description": {
   "orderby": 286,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/document-link/description/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/document-link",
    "/description/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 287,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/document-link/description/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/document-link",
    "/description/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/document-link/document-date": {
   "orderby": 408,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/document-link/document-date@iso-date": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/document-link",
    "/document-date@iso-date"
   ],
   "orderby": 409,
   "required": true,
   "type": "date"
  },
  "/iati-activities/iati-activity/result/document-link/language": {
   "multiple": true,
   "orderby": 406,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/document-link/language@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/document-link",
    "/language",
    "@code"
   ],
   "orderby": 407,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/document-link/title": {
   "orderby": 283,
   "required": true,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/document-link/title/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/document-link",
    "/title/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 284,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/document-link/title/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/document-link",
    "/title/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/document-link@format": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/document-link",
    "@format"
   ],
   "orderby": 397,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/document-link@url": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/document-link",
    "@url"
   ],
   "orderby": 396,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator": {
   "multiple": true,
   "orderby": 299,
   "required": true,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/baseline": {
   "multiple": true,
   "orderby": 328,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/baseline/comment": {
   "orderby": 352,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/baseline/comment/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/baseline",
    "/comment/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 353,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/baseline/comment/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/baseline",
    "/comment/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/baseline/dimension": {
   "multiple": true,
   "orderby": 334,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/baseline/dimension@name": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/baseline",
    "/dimension",
    "@name"
   ],
   "orderby": 390,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/baseline/dimension@value": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/baseline",
    "/dimension",
    "@value"
   ],
   "orderby": 391,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/baseline/document-link": {
   "multiple": true,
   "orderby": 337,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/baseline/document-link/category": {
   "multiple": true,
   "orderby": 404,
   "required": true,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/baseline/document-link/category@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/baseline",
    "/document-link",
    "/category",
    "@code"
   ],
   "orderby": 405,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/baseline/document-link/description": {
   "orderby": 343,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/baseline/document-link/description/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/baseline",
    "/document-link",
    "/description/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 344,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/baseline/document-link/description/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/baseline",
    "/document-link",
    "/description/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/baseline/document-link/document-date": {
   "orderby": 408,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/baseline/document-link/document-date@iso-date": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/baseline",
    "/document-link",
    "/document-date@iso-date"
   ],
   "orderby": 409,
   "required": true,
   "type": "date"
  },
  "/iati-activities/iati-activity/result/indicator/baseline/document-link/language": {
   "multiple": true,
   "orderby": 406,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/baseline/document-link/language@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/baseline",
    "/document-link",
    "/language",
    "@code"
   ],
   "orderby": 407,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/baseline/document-link/title": {
   "orderby": 340,
   "required": true,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/baseline/document-link/title/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/baseline",
    "/document-link",
    "/title/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 341,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/baseline/document-link/title/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/baseline",
    "/document-link",
    "/title/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/baseline/document-link@format": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/baseline",
    "/document-link",
    "@format"
   ],
   "orderby": 397,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/baseline/document-link@url": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/baseline",
    "/document-link",
    "@url"
   ],
   "orderby": 396,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/baseline/location": {
   "multiple": true,
   "orderby": 332,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/baseline/location@ref": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/baseline",
    "/location",
    "@ref"
   ],
   "orderby": 388,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/baseline@iso-date": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/baseline",
    "@iso-date"
   ],
   "orderby": 329,
   "type": "date"
  },
  "/iati-activities/iati-activity/result/indicator/baseline@value": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/baseline",
    "@value"
   ],
   "orderby": 331,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/baseline@year": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/baseline",
    "@year"
   ],
   "orderby": 330,
   "required": true,
   "type": "uint"
  },
  "/iati-activities/iati-activity/result/indicator/description": {
   "orderby": 306,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/description/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/description/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 307,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/description/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/description/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/document-link": {
   "multiple": true,
   "orderby": 309,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/document-link/category": {
   "multiple": true,
   "orderby": 404,
   "required": true,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/document-link/category@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/document-link",
    "/category",
    "@code"
   ],
   "orderby": 405,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/document-link/description": {
   "orderby": 315,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/document-link/description/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/document-link",
    "/description/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 316,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/document-link/description/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/document-link",
    "/description/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/document-link/document-date": {
   "orderby": 408,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/document-link/document-date@iso-date": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/document-link",
    "/document-date@iso-date"
   ],
   "orderby": 409,
   "required": true,
   "type": "date"
  },
  "/iati-activities/iati-activity/result/indicator/document-link/language": {
   "multiple": true,
   "orderby": 406,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/document-link/language@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/document-link",
    "/language",
    "@code"
   ],
   "orderby": 407,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/document-link/title": {
   "orderby": 312,
   "required": true,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/document-link/title/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/document-link",
    "/title/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 313,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/document-link/title/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/document-link",
    "/title/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/document-link@format": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/document-link",
    "@format"
   ],
   "orderby": 397,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/document-link@url": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/document-link",
    "@url"
   ],
   "orderby": 396,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/period": {
   "multiple": true,
   "orderby": 355,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/period/actual": {
   "multiple": true,
   "orderby": 385,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/period/actual/comment": {
   "orderby": 392,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/period/actual/comment/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/period",
    "/actual",
    "/comment/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 393,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/period/actual/comment/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/period",
    "/actual",
    "/comment/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/period/actual/dimension": {
   "multiple": true,
   "orderby": 389,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/period/actual/dimension@name": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/period",
    "/actual",
    "/dimension",
    "@name"
   ],
   "orderby": 390,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/period/actual/dimension@value": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/period",
    "/actual",
    "/dimension",
    "@value"
   ],
   "orderby": 391,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/period/actual/document-link": {
   "multiple": true,
   "orderby": 395,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/period/actual/document-link/category": {
   "multiple": true,
   "orderby": 404,
   "required": true,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/period/actual/document-link/category@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/period",
    "/actual",
    "/document-link",
    "/category",
    "@code"
   ],
   "orderby": 405,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/period/actual/document-link/description": {
   "orderby": 401,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/period/actual/document-link/description/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/period",
    "/actual",
    "/document-link",
    "/description/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 402,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/period/actual/document-link/description/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/period",
    "/actual",
    "/document-link",
    "/description/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/period/actual/document-link/document-date": {
   "orderby": 408,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/period/actual/document-link/document-date@iso-date": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/period",
    "/actual",
    "/document-link",
    "/document-date@iso-date"
   ],
   "orderby": 409,
   "required": true,
   "type": "date"
  },
  "/iati-activities/iati-activity/result/indicator/period/actual/document-link/language": {
   "multiple": true,
   "orderby": 406,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/period/actual/document-link/language@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/period",
    "/actual",
    "/document-link",
    "/language",
    "@code"
   ],
   "orderby": 407,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/period/actual/document-link/title": {
   "orderby": 398,
   "required": true,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/period/actual/document-link/title/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/period",
    "/actual",
    "/document-link",
    "/title/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 399,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/period/actual/document-link/title/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/period",
    "/actual",
    "/document-link",
    "/title/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/period/actual/document-link@format": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/period",
    "/actual",
    "/document-link",
    "@format"
   ],
   "orderby": 397,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/period/actual/document-link@url": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/period",
    "/actual",
    "/document-link",
    "@url"
   ],
   "orderby": 396,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/period/actual/location": {
   "multiple": true,
   "orderby": 387,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/period/actual/location@ref": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/period",
    "/actual",
    "/location",
    "@ref"
   ],
   "orderby": 388,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/period/actual@value": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/period",
    "/actual",
    "@value"
   ],
   "orderby": 386,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/period/period-end": {
   "orderby": 358,
   "required": true,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/period/period-end@iso-date": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/period",
    "/period-end@iso-date"
   ],
   "orderby": 359,
   "required": true,
   "type": "date"
  },
  "/iati-activities/iati-activity/result/indicator/period/period-start": {
   "orderby": 356,
   "required": true,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/period/period-start@iso-date": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/period",
    "/period-start@iso-date"
   ],
   "orderby": 357,
   "required": true,
   "type": "date"
  },
  "/iati-activities/iati-activity/result/indicator/period/target": {
   "multiple": true,
   "orderby": 360,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/period/target/comment": {
   "orderby": 367,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/period/target/comment/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/period",
    "/target",
    "/comment/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 368,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/period/target/comment/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/period",
    "/target",
    "/comment/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/period/target/dimension": {
   "multiple": true,
   "orderby": 364,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/period/target/dimension@name": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/period",
    "/target",
    "/dimension",
    "@name"
   ],
   "orderby": 390,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/period/target/dimension@value": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/period",
    "/target",
    "/dimension",
    "@value"
   ],
   "orderby": 391,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/period/target/document-link": {
   "multiple": true,
   "orderby": 370,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/period/target/document-link/category": {
   "multiple": true,
   "orderby": 404,
   "required": true,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/period/target/document-link/category@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/period",
    "/target",
    "/document-link",
    "/category",
    "@code"
   ],
   "orderby": 405,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/period/target/document-link/description": {
   "orderby": 376,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/period/target/document-link/description/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/period",
    "/target",
    "/document-link",
    "/description/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 377,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/period/target/document-link/description/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/period",
    "/target",
    "/document-link",
    "/description/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/period/target/document-link/document-date": {
   "orderby": 408,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/period/target/document-link/document-date@iso-date": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/period",
    "/target",
    "/document-link",
    "/document-date@iso-date"
   ],
   "orderby": 409,
   "required": true,
   "type": "date"
  },
  "/iati-activities/iati-activity/result/indicator/period/target/document-link/language": {
   "multiple": true,
   "orderby": 406,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/period/target/document-link/language@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/period",
    "/target",
    "/document-link",
    "/language",
    "@code"
   ],
   "orderby": 407,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/period/target/document-link/title": {
   "orderby": 373,
   "required": true,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/period/target/document-link/title/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/period",
    "/target",
    "/document-link",
    "/title/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 374,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/period/target/document-link/title/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/period",
    "/target",
    "/document-link",
    "/title/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/period/target/document-link@format": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/period",
    "/target",
    "/document-link",
    "@format"
   ],
   "orderby": 397,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/period/target/document-link@url": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/period",
    "/target",
    "/document-link",
    "@url"
   ],
   "orderby": 396,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/period/target/location": {
   "multiple": true,
   "orderby": 362,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/period/target/location@ref": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/period",
    "/target",
    "/location",
    "@ref"
   ],
   "orderby": 388,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/period/target@value": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/period",
    "/target",
    "@value"
   ],
   "orderby": 361,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/reference": {
   "multiple": true,
   "orderby": 324,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/reference@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/reference",
    "@code"
   ],
   "orderby": 326,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/reference@indicator-uri": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/reference",
    "@indicator-uri"
   ],
   "orderby": 327,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/reference@vocabulary": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/reference",
    "@vocabulary"
   ],
   "orderby": 325,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/title": {
   "orderby": 303,
   "required": true,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/indicator/title/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/title/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 304,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator/title/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "/title/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/indicator@aggregation-status": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "@aggregation-status"
   ],
   "orderby": 302,
   "type": "bool"
  },
  "/iati-activities/iati-activity/result/indicator@ascending": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "@ascending"
   ],
   "orderby": 301,
   "type": "bool"
  },
  "/iati-activities/iati-activity/result/indicator@measure": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/indicator",
    "@measure"
   ],
   "orderby": 300,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/reference": {
   "multiple": true,
   "orderby": 295,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/reference@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/reference",
    "@code"
   ],
   "orderby": 296,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/reference@vocabulary": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/reference",
    "@vocabulary"
   ],
   "orderby": 297,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/reference@vocabulary-uri": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/reference",
    "@vocabulary-uri"
   ],
   "orderby": 298,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/title": {
   "orderby": 274,
   "required": true,
   "type": "null"
  },
  "/iati-activities/iati-activity/result/title/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/title/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 275,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/result/title/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "/title/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/result@aggregation-status": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "@aggregation-status"
   ],
   "orderby": 273,
   "type": "bool"
  },
  "/iati-activities/iati-activity/result@type": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/result",
    "@type"
   ],
   "orderby": 272,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/sector": {
   "multiple": true,
   "orderby": 112,
   "type": "null"
  },
  "/iati-activities/iati-activity/sector/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/sector",
    "/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 117,
   "type": "text"
  },
  "/iati-activities/iati-activity/sector/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/sector",
    "/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/sector@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/sector",
    "@code"
   ],
   "orderby": 115,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/sector@percentage": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/sector",
    "@percentage"
   ],
   "orderby": 116,
   "type": "number"
  },
  "/iati-activities/iati-activity/sector@vocabulary": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/sector",
    "@vocabulary"
   ],
   "orderby": 113,
   "type": "text"
  },
  "/iati-activities/iati-activity/sector@vocabulary-uri": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/sector",
    "@vocabulary-uri"
   ],
   "orderby": 114,
   "type": "text"
  },
  "/iati-activities/iati-activity/tag": {
   "multiple": true,
   "orderby": 119,
   "type": "null"
  },
  "/iati-activities/iati-activity/tag/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/tag",
    "/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 123,
   "type": "text"
  },
  "/iati-activities/iati-activity/tag/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/tag",
    "/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/tag@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/tag",
    "@code"
   ],
   "orderby": 120,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/tag@vocabulary": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/tag",
    "@vocabulary"
   ],
   "orderby": 121,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/tag@vocabulary-uri": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/tag",
    "@vocabulary-uri"
   ],
   "orderby": 122,
   "type": "text"
  },
  "/iati-activities/iati-activity/title": {
   "orderby": 20,
   "required": true,
   "type": "null"
  },
  "/iati-activities/iati-activity/title/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/title/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 21,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/title/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/title/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/transaction": {
   "multiple": true,
   "orderby": 191,
   "type": "null"
  },
  "/iati-activities/iati-activity/transaction/aid-type": {
   "multiple": true,
   "orderby": 238,
   "type": "null"
  },
  "/iati-activities/iati-activity/transaction/aid-type@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "/aid-type",
    "@code"
   ],
   "orderby": 239,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/transaction/aid-type@vocabulary": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "/aid-type",
    "@vocabulary"
   ],
   "orderby": 240,
   "type": "text"
  },
  "/iati-activities/iati-activity/transaction/description": {
   "orderby": 201,
   "type": "null"
  },
  "/iati-activities/iati-activity/transaction/description/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "/description/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 202,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/transaction/description/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "/description/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/transaction/disbursement-channel": {
   "orderby": 216,
   "type": "null"
  },
  "/iati-activities/iati-activity/transaction/disbursement-channel@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "/disbursement-channel@code"
   ],
   "orderby": 217,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/transaction/finance-type": {
   "orderby": 236,
   "type": "null"
  },
  "/iati-activities/iati-activity/transaction/finance-type@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "/finance-type@code"
   ],
   "orderby": 237,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/transaction/flow-type": {
   "orderby": 234,
   "type": "null"
  },
  "/iati-activities/iati-activity/transaction/flow-type@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "/flow-type@code"
   ],
   "orderby": 235,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/transaction/provider-org": {
   "orderby": 204,
   "type": "null"
  },
  "/iati-activities/iati-activity/transaction/provider-org/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "/provider-org/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 208,
   "type": "text"
  },
  "/iati-activities/iati-activity/transaction/provider-org/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "/provider-org/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/transaction/provider-org@provider-activity-id": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "/provider-org@provider-activity-id"
   ],
   "orderby": 206,
   "type": "text"
  },
  "/iati-activities/iati-activity/transaction/provider-org@ref": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "/provider-org@ref"
   ],
   "orderby": 205,
   "type": "text"
  },
  "/iati-activities/iati-activity/transaction/provider-org@type": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "/provider-org@type"
   ],
   "orderby": 207,
   "type": "text"
  },
  "/iati-activities/iati-activity/transaction/receiver-org": {
   "orderby": 210,
   "type": "null"
  },
  "/iati-activities/iati-activity/transaction/receiver-org/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "/receiver-org/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 214,
   "type": "text"
  },
  "/iati-activities/iati-activity/transaction/receiver-org/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "/receiver-org/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/transaction/receiver-org@receiver-activity-id": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "/receiver-org@receiver-activity-id"
   ],
   "orderby": 212,
   "type": "text"
  },
  "/iati-activities/iati-activity/transaction/receiver-org@ref": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "/receiver-org@ref"
   ],
   "orderby": 211,
   "type": "text"
  },
  "/iati-activities/iati-activity/transaction/receiver-org@type": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "/receiver-org@type"
   ],
   "orderby": 213,
   "type": "text"
  },
  "/iati-activities/iati-activity/transaction/recipient-country": {
   "orderby": 224,
   "type": "null"
  },
  "/iati-activities/iati-activity/transaction/recipient-country/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "/recipient-country/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 226,
   "type": "text"
  },
  "/iati-activities/iati-activity/transaction/recipient-country/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "/recipient-country/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/transaction/recipient-country@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "/recipient-country@code"
   ],
   "orderby": 225,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/transaction/recipient-region": {
   "orderby": 228,
   "type": "null"
  },
  "/iati-activities/iati-activity/transaction/recipient-region/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "/recipient-region/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 232,
   "type": "text"
  },
  "/iati-activities/iati-activity/transaction/recipient-region/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "/recipient-region/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/transaction/recipient-region@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "/recipient-region@code"
   ],
   "orderby": 229,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/transaction/recipient-region@vocabulary": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "/recipient-region@vocabulary"
   ],
   "orderby": 230,
   "type": "text"
  },
  "/iati-activities/iati-activity/transaction/recipient-region@vocabulary-uri": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "/recipient-region@vocabulary-uri"
   ],
   "orderby": 231,
   "type": "text"
  },
  "/iati-activities/iati-activity/transaction/sector": {
   "multiple": true,
   "orderby": 218,
   "type": "null"
  },
  "/iati-activities/iati-activity/transaction/sector/narrative": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "/sector",
    "/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 222,
   "type": "text"
  },
  "/iati-activities/iati-activity/transaction/sector/narrative@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "/sector",
    "/narrative",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities/iati-activity/transaction/sector@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "/sector",
    "@code"
   ],
   "orderby": 221,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/transaction/sector@vocabulary": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "/sector",
    "@vocabulary"
   ],
   "orderby": 219,
   "type": "text"
  },
  "/iati-activities/iati-activity/transaction/sector@vocabulary-uri": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "/sector",
    "@vocabulary-uri"
   ],
   "orderby": 220,
   "type": "text"
  },
  "/iati-activities/iati-activity/transaction/tied-status": {
   "orderby": 241,
   "type": "null"
  },
  "/iati-activities/iati-activity/transaction/tied-status@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "/tied-status@code"
   ],
   "orderby": 242,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/transaction/transaction-date": {
   "orderby": 196,
   "required": true,
   "type": "null"
  },
  "/iati-activities/iati-activity/transaction/transaction-date@iso-date": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "/transaction-date@iso-date"
   ],
   "orderby": 197,
   "required": true,
   "type": "date"
  },
  "/iati-activities/iati-activity/transaction/transaction-type": {
   "orderby": 194,
   "required": true,
   "type": "null"
  },
  "/iati-activities/iati-activity/transaction/transaction-type@code": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "/transaction-type@code"
   ],
   "orderby": 195,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity/transaction/value": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "/value"
   ],
   "orderby": 198,
   "required": true,
   "type": "number"
  },
  "/iati-activities/iati-activity/transaction/value@currency": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "/value@currency"
   ],
   "orderby": 442,
   "type": "text"
  },
  "/iati-activities/iati-activity/transaction/value@value-date": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "/value@value-date"
   ],
   "orderby": 443,
   "type": "date"
  },
  "/iati-activities/iati-activity/transaction@humanitarian": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "@humanitarian"
   ],
   "orderby": 193,
   "type": "bool"
  },
  "/iati-activities/iati-activity/transaction@ref": {
   "jpath": [
    "/iati-activities/iati-activity",
    "/transaction",
    "@ref"
   ],
   "orderby": 192,
   "type": "text"
  },
  "/iati-activities/iati-activity@budget-not-provided": {
   "jpath": [
    "/iati-activities/iati-activity",
    "@budget-not-provided"
   ],
   "orderby": 12,
   "type": "text"
  },
  "/iati-activities/iati-activity@default-currency": {
   "jpath": [
    "/iati-activities/iati-activity",
    "@default-currency"
   ],
   "orderby": 8,
   "type": "text"
  },
  "/iati-activities/iati-activity@hierarchy": {
   "jpath": [
    "/iati-activities/iati-activity",
    "@hierarchy"
   ],
   "orderby": 10,
   "type": "int"
  },
  "/iati-activities/iati-activity@humanitarian": {
   "jpath": [
    "/iati-activities/iati-activity",
    "@humanitarian"
   ],
   "orderby": 9,
   "type": "bool"
  },
  "/iati-activities/iati-activity@iati-activities:generated-datetime": {
   "jpath": [
    "/iati-activities/iati-activity",
    "@iati-activities:generated-datetime"
   ],
   "orderby": 3,
   "type": "time"
  },
  "/iati-activities/iati-activity@iati-activities:linked-data-default": {
   "jpath": [
    "/iati-activities/iati-activity",
    "@iati-activities:linked-data-default"
   ],
   "orderby": 4,
   "type": "text"
  },
  "/iati-activities/iati-activity@iati-activities:version": {
   "jpath": [
    "/iati-activities/iati-activity",
    "@iati-activities:version"
   ],
   "orderby": 2,
   "required": true,
   "type": "text"
  },
  "/iati-activities/iati-activity@last-updated-datetime": {
   "jpath": [
    "/iati-activities/iati-activity",
    "@last-updated-datetime"
   ],
   "orderby": 6,
   "type": "time"
  },
  "/iati-activities/iati-activity@linked-data-uri": {
   "jpath": [
    "/iati-activities/iati-activity",
    "@linked-data-uri"
   ],
   "orderby": 11,
   "type": "text"
  },
  "/iati-activities/iati-activity@xml:lang": {
   "jpath": [
    "/iati-activities/iati-activity",
    "@xml:lang"
   ],
   "orderby": 403,
   "type": "text"
  },
  "/iati-activities@generated-datetime": {
   "jpath": [
    "/iati-activities@generated-datetime"
   ],
   "orderby": 3,
   "type": "time"
  },
  "/iati-activities@linked-data-default": {
   "jpath": [
    "/iati-activities@linked-data-default"
   ],
   "orderby": 4,
   "type": "text"
  },
  "/iati-activities@version": {
   "jpath": [
    "/iati-activities@version"
   ],
   "orderby": 2,
   "required": true,
   "type": "text"
  },
  "/iati-organisations": {
   "orderby": 1,
   "type": "null"
  },
  "/iati-organisations/iati-organisation": {
   "multiple": true,
   "orderby": 4,
   "required": true,
   "type": "null"
  },
  "/iati-organisations/iati-organisation/document-link": {
   "multiple": true,
   "orderby": 111,
   "type": "null"
  },
  "/iati-organisations/iati-organisation/document-link/category": {
   "multiple": true,
   "orderby": 124,
   "required": true,
   "type": "null"
  },
  "/iati-organisations/iati-organisation/document-link/category@code": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/document-link",
    "/category",
    "@code"
   ],
   "orderby": 125,
   "required": true,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/document-link/description": {
   "orderby": 121,
   "type": "null"
  },
  "/iati-organisations/iati-organisation/document-link/description/narrative": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/document-link",
    "/description/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 122,
   "required": true,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/document-link/description/narrative@xml:lang": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/document-link",
    "/description/narrative",
    "@xml:lang"
   ],
   "orderby": 123,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/document-link/document-date": {
   "orderby": 128,
   "type": "null"
  },
  "/iati-organisations/iati-organisation/document-link/document-date@iso-date": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/document-link",
    "/document-date@iso-date"
   ],
   "orderby": 129,
   "required": true,
   "type": "date"
  },
  "/iati-organisations/iati-organisation/document-link/language": {
   "multiple": true,
   "orderby": 126,
   "type": "null"
  },
  "/iati-organisations/iati-organisation/document-link/language@code": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/document-link",
    "/language",
    "@code"
   ],
   "orderby": 127,
   "required": true,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/document-link/recipient-country": {
   "multiple": true,
   "orderby": 114,
   "type": "null"
  },
  "/iati-organisations/iati-organisation/document-link/recipient-country/narrative": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/document-link",
    "/recipient-country",
    "/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 116,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/document-link/recipient-country/narrative@xml:lang": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/document-link",
    "/recipient-country",
    "/narrative",
    "@xml:lang"
   ],
   "orderby": 123,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/document-link/recipient-country@code": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/document-link",
    "/recipient-country",
    "@code"
   ],
   "orderby": 115,
   "required": true,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/document-link/title": {
   "orderby": 118,
   "required": true,
   "type": "null"
  },
  "/iati-organisations/iati-organisation/document-link/title/narrative": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/document-link",
    "/title/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 119,
   "required": true,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/document-link/title/narrative@xml:lang": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/document-link",
    "/title/narrative",
    "@xml:lang"
   ],
   "orderby": 123,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/document-link@format": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/document-link",
    "@format"
   ],
   "orderby": 113,
   "required": true,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/document-link@url": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/document-link",
    "@url"
   ],
   "orderby": 112,
   "required": true,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/name": {
   "orderby": 9,
   "required": true,
   "type": "null"
  },
  "/iati-organisations/iati-organisation/name/narrative": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/name/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 10,
   "required": true,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/name/narrative@xml:lang": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/name/narrative",
    "@xml:lang"
   ],
   "orderby": 123,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/organisation-identifier": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/organisation-identifier"
   ],
   "orderby": 8,
   "required": true,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/recipient-country-budget": {
   "multiple": true,
   "orderby": 76,
   "type": "null"
  },
  "/iati-organisations/iati-organisation/recipient-country-budget/budget-line": {
   "multiple": true,
   "orderby": 89,
   "type": "null"
  },
  "/iati-organisations/iati-organisation/recipient-country-budget/budget-line/narrative": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-country-budget",
    "/budget-line",
    "/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 94,
   "required": true,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/recipient-country-budget/budget-line/narrative@xml:lang": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-country-budget",
    "/budget-line",
    "/narrative",
    "@xml:lang"
   ],
   "orderby": 123,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/recipient-country-budget/budget-line/value": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-country-budget",
    "/budget-line",
    "/value"
   ],
   "orderby": 91,
   "required": true,
   "type": "number"
  },
  "/iati-organisations/iati-organisation/recipient-country-budget/budget-line/value@currency": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-country-budget",
    "/budget-line",
    "/value@currency"
   ],
   "orderby": 107,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/recipient-country-budget/budget-line/value@value-date": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-country-budget",
    "/budget-line",
    "/value@value-date"
   ],
   "orderby": 108,
   "type": "date"
  },
  "/iati-organisations/iati-organisation/recipient-country-budget/budget-line@ref": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-country-budget",
    "/budget-line",
    "@ref"
   ],
   "orderby": 90,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/recipient-country-budget/period-end": {
   "orderby": 84,
   "required": true,
   "type": "null"
  },
  "/iati-organisations/iati-organisation/recipient-country-budget/period-end@iso-date": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-country-budget",
    "/period-end@iso-date"
   ],
   "orderby": 85,
   "required": true,
   "type": "date"
  },
  "/iati-organisations/iati-organisation/recipient-country-budget/period-start": {
   "orderby": 82,
   "required": true,
   "type": "null"
  },
  "/iati-organisations/iati-organisation/recipient-country-budget/period-start@iso-date": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-country-budget",
    "/period-start@iso-date"
   ],
   "orderby": 83,
   "required": true,
   "type": "date"
  },
  "/iati-organisations/iati-organisation/recipient-country-budget/recipient-country": {
   "orderby": 78,
   "required": true,
   "type": "null"
  },
  "/iati-organisations/iati-organisation/recipient-country-budget/recipient-country/narrative": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-country-budget",
    "/recipient-country/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 80,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/recipient-country-budget/recipient-country/narrative@xml:lang": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-country-budget",
    "/recipient-country/narrative",
    "@xml:lang"
   ],
   "orderby": 123,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/recipient-country-budget/recipient-country@code": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-country-budget",
    "/recipient-country@code"
   ],
   "orderby": 79,
   "required": true,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/recipient-country-budget/value": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-country-budget",
    "/value"
   ],
   "orderby": 86,
   "required": true,
   "type": "number"
  },
  "/iati-organisations/iati-organisation/recipient-country-budget/value@currency": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-country-budget",
    "/value@currency"
   ],
   "orderby": 107,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/recipient-country-budget/value@value-date": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-country-budget",
    "/value@value-date"
   ],
   "orderby": 108,
   "type": "date"
  },
  "/iati-organisations/iati-organisation/recipient-country-budget@status": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-country-budget",
    "@status"
   ],
   "orderby": 77,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/recipient-org-budget": {
   "multiple": true,
   "orderby": 34,
   "type": "null"
  },
  "/iati-organisations/iati-organisation/recipient-org-budget/budget-line": {
   "multiple": true,
   "orderby": 47,
   "type": "null"
  },
  "/iati-organisations/iati-organisation/recipient-org-budget/budget-line/narrative": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-org-budget",
    "/budget-line",
    "/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 52,
   "required": true,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/recipient-org-budget/budget-line/narrative@xml:lang": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-org-budget",
    "/budget-line",
    "/narrative",
    "@xml:lang"
   ],
   "orderby": 123,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/recipient-org-budget/budget-line/value": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-org-budget",
    "/budget-line",
    "/value"
   ],
   "orderby": 49,
   "required": true,
   "type": "number"
  },
  "/iati-organisations/iati-organisation/recipient-org-budget/budget-line/value@currency": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-org-budget",
    "/budget-line",
    "/value@currency"
   ],
   "orderby": 107,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/recipient-org-budget/budget-line/value@value-date": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-org-budget",
    "/budget-line",
    "/value@value-date"
   ],
   "orderby": 108,
   "type": "date"
  },
  "/iati-organisations/iati-organisation/recipient-org-budget/budget-line@ref": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-org-budget",
    "/budget-line",
    "@ref"
   ],
   "orderby": 48,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/recipient-org-budget/period-end": {
   "orderby": 42,
   "required": true,
   "type": "null"
  },
  "/iati-organisations/iati-organisation/recipient-org-budget/period-end@iso-date": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-org-budget",
    "/period-end@iso-date"
   ],
   "orderby": 43,
   "required": true,
   "type": "date"
  },
  "/iati-organisations/iati-organisation/recipient-org-budget/period-start": {
   "orderby": 40,
   "required": true,
   "type": "null"
  },
  "/iati-organisations/iati-organisation/recipient-org-budget/period-start@iso-date": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-org-budget",
    "/period-start@iso-date"
   ],
   "orderby": 41,
   "required": true,
   "type": "date"
  },
  "/iati-organisations/iati-organisation/recipient-org-budget/recipient-org": {
   "orderby": 36,
   "required": true,
   "type": "null"
  },
  "/iati-organisations/iati-organisation/recipient-org-budget/recipient-org/narrative": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-org-budget",
    "/recipient-org/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 38,
   "required": true,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/recipient-org-budget/recipient-org/narrative@xml:lang": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-org-budget",
    "/recipient-org/narrative",
    "@xml:lang"
   ],
   "orderby": 123,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/recipient-org-budget/recipient-org@ref": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-org-budget",
    "/recipient-org@ref"
   ],
   "orderby": 37,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/recipient-org-budget/value": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-org-budget",
    "/value"
   ],
   "orderby": 44,
   "required": true,
   "type": "number"
  },
  "/iati-organisations/iati-organisation/recipient-org-budget/value@currency": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-org-budget",
    "/value@currency"
   ],
   "orderby": 107,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/recipient-org-budget/value@value-date": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-org-budget",
    "/value@value-date"
   ],
   "orderby": 108,
   "type": "date"
  },
  "/iati-organisations/iati-organisation/recipient-org-budget@status": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-org-budget",
    "@status"
   ],
   "orderby": 35,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/recipient-region-budget": {
   "multiple": true,
   "orderby": 54,
   "type": "null"
  },
  "/iati-organisations/iati-organisation/recipient-region-budget/budget-line": {
   "multiple": true,
   "orderby": 69,
   "type": "null"
  },
  "/iati-organisations/iati-organisation/recipient-region-budget/budget-line/narrative": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-region-budget",
    "/budget-line",
    "/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 74,
   "required": true,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/recipient-region-budget/budget-line/narrative@xml:lang": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-region-budget",
    "/budget-line",
    "/narrative",
    "@xml:lang"
   ],
   "orderby": 123,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/recipient-region-budget/budget-line/value": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-region-budget",
    "/budget-line",
    "/value"
   ],
   "orderby": 71,
   "required": true,
   "type": "number"
  },
  "/iati-organisations/iati-organisation/recipient-region-budget/budget-line/value@currency": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-region-budget",
    "/budget-line",
    "/value@currency"
   ],
   "orderby": 107,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/recipient-region-budget/budget-line/value@value-date": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-region-budget",
    "/budget-line",
    "/value@value-date"
   ],
   "orderby": 108,
   "type": "date"
  },
  "/iati-organisations/iati-organisation/recipient-region-budget/budget-line@ref": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-region-budget",
    "/budget-line",
    "@ref"
   ],
   "orderby": 70,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/recipient-region-budget/period-end": {
   "orderby": 64,
   "required": true,
   "type": "null"
  },
  "/iati-organisations/iati-organisation/recipient-region-budget/period-end@iso-date": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-region-budget",
    "/period-end@iso-date"
   ],
   "orderby": 65,
   "required": true,
   "type": "date"
  },
  "/iati-organisations/iati-organisation/recipient-region-budget/period-start": {
   "orderby": 62,
   "required": true,
   "type": "null"
  },
  "/iati-organisations/iati-organisation/recipient-region-budget/period-start@iso-date": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-region-budget",
    "/period-start@iso-date"
   ],
   "orderby": 63,
   "required": true,
   "type": "date"
  },
  "/iati-organisations/iati-organisation/recipient-region-budget/recipient-region": {
   "orderby": 56,
   "required": true,
   "type": "null"
  },
  "/iati-organisations/iati-organisation/recipient-region-budget/recipient-region/narrative": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-region-budget",
    "/recipient-region/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 60,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/recipient-region-budget/recipient-region/narrative@xml:lang": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-region-budget",
    "/recipient-region/narrative",
    "@xml:lang"
   ],
   "orderby": 123,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/recipient-region-budget/recipient-region@code": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-region-budget",
    "/recipient-region@code"
   ],
   "orderby": 59,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/recipient-region-budget/recipient-region@vocabulary": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-region-budget",
    "/recipient-region@vocabulary"
   ],
   "orderby": 57,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/recipient-region-budget/recipient-region@vocabulary-uri": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-region-budget",
    "/recipient-region@vocabulary-uri"
   ],
   "orderby": 58,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/recipient-region-budget/value": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-region-budget",
    "/value"
   ],
   "orderby": 66,
   "required": true,
   "type": "number"
  },
  "/iati-organisations/iati-organisation/recipient-region-budget/value@currency": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-region-budget",
    "/value@currency"
   ],
   "orderby": 107,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/recipient-region-budget/value@value-date": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-region-budget",
    "/value@value-date"
   ],
   "orderby": 108,
   "type": "date"
  },
  "/iati-organisations/iati-organisation/recipient-region-budget@status": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/recipient-region-budget",
    "@status"
   ],
   "orderby": 55,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/reporting-org": {
   "orderby": 12,
   "required": true,
   "type": "null"
  },
  "/iati-organisations/iati-organisation/reporting-org/narrative": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/reporting-org/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 16,
   "required": true,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/reporting-org/narrative@xml:lang": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/reporting-org/narrative",
    "@xml:lang"
   ],
   "orderby": 123,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/reporting-org@ref": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/reporting-org@ref"
   ],
   "orderby": 13,
   "required": true,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/reporting-org@secondary-reporter": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/reporting-org@secondary-reporter"
   ],
   "orderby": 15,
   "type": "bool"
  },
  "/iati-organisations/iati-organisation/reporting-org@type": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/reporting-org@type"
   ],
   "orderby": 14,
   "required": true,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/total-budget": {
   "multiple": true,
   "orderby": 18,
   "type": "null"
  },
  "/iati-organisations/iati-organisation/total-budget/budget-line": {
   "multiple": true,
   "orderby": 27,
   "type": "null"
  },
  "/iati-organisations/iati-organisation/total-budget/budget-line/narrative": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/total-budget",
    "/budget-line",
    "/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 32,
   "required": true,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/total-budget/budget-line/narrative@xml:lang": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/total-budget",
    "/budget-line",
    "/narrative",
    "@xml:lang"
   ],
   "orderby": 123,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/total-budget/budget-line/value": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/total-budget",
    "/budget-line",
    "/value"
   ],
   "orderby": 29,
   "required": true,
   "type": "number"
  },
  "/iati-organisations/iati-organisation/total-budget/budget-line/value@currency": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/total-budget",
    "/budget-line",
    "/value@currency"
   ],
   "orderby": 107,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/total-budget/budget-line/value@value-date": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/total-budget",
    "/budget-line",
    "/value@value-date"
   ],
   "orderby": 108,
   "type": "date"
  },
  "/iati-organisations/iati-organisation/total-budget/budget-line@ref": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/total-budget",
    "/budget-line",
    "@ref"
   ],
   "orderby": 28,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/total-budget/period-end": {
   "orderby": 22,
   "required": true,
   "type": "null"
  },
  "/iati-organisations/iati-organisation/total-budget/period-end@iso-date": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/total-budget",
    "/period-end@iso-date"
   ],
   "orderby": 23,
   "required": true,
   "type": "date"
  },
  "/iati-organisations/iati-organisation/total-budget/period-start": {
   "orderby": 20,
   "required": true,
   "type": "null"
  },
  "/iati-organisations/iati-organisation/total-budget/period-start@iso-date": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/total-budget",
    "/period-start@iso-date"
   ],
   "orderby": 21,
   "required": true,
   "type": "date"
  },
  "/iati-organisations/iati-organisation/total-budget/value": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/total-budget",
    "/value"
   ],
   "orderby": 24,
   "required": true,
   "type": "number"
  },
  "/iati-organisations/iati-organisation/total-budget/value@currency": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/total-budget",
    "/value@currency"
   ],
   "orderby": 107,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/total-budget/value@value-date": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/total-budget",
    "/value@value-date"
   ],
   "orderby": 108,
   "type": "date"
  },
  "/iati-organisations/iati-organisation/total-budget@status": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/total-budget",
    "@status"
   ],
   "orderby": 19,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/total-expenditure": {
   "multiple": true,
   "orderby": 96,
   "type": "null"
  },
  "/iati-organisations/iati-organisation/total-expenditure/expense-line": {
   "multiple": true,
   "orderby": 104,
   "type": "null"
  },
  "/iati-organisations/iati-organisation/total-expenditure/expense-line/narrative": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/total-expenditure",
    "/expense-line",
    "/narrative",
    ""
   ],
   "multiple": true,
   "orderby": 109,
   "required": true,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/total-expenditure/expense-line/narrative@xml:lang": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/total-expenditure",
    "/expense-line",
    "/narrative",
    "@xml:lang"
   ],
   "orderby": 123,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/total-expenditure/expense-line/value": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/total-expenditure",
    "/expense-line",
    "/value"
   ],
   "orderby": 106,
   "required": true,
   "type": "number"
  },
  "/iati-organisations/iati-organisation/total-expenditure/expense-line/value@currency": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/total-expenditure",
    "/expense-line",
    "/value@currency"
   ],
   "orderby": 107,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/total-expenditure/expense-line/value@value-date": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/total-expenditure",
    "/expense-line",
    "/value@value-date"
   ],
   "orderby": 108,
   "type": "date"
  },
  "/iati-organisations/iati-organisation/total-expenditure/expense-line@ref": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/total-expenditure",
    "/expense-line",
    "@ref"
   ],
   "orderby": 105,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/total-expenditure/period-end": {
   "orderby": 99,
   "required": true,
   "type": "null"
  },
  "/iati-organisations/iati-organisation/total-expenditure/period-end@iso-date": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/total-expenditure",
    "/period-end@iso-date"
   ],
   "orderby": 100,
   "required": true,
   "type": "date"
  },
  "/iati-organisations/iati-organisation/total-expenditure/period-start": {
   "orderby": 97,
   "required": true,
   "type": "null"
  },
  "/iati-organisations/iati-organisation/total-expenditure/period-start@iso-date": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/total-expenditure",
    "/period-start@iso-date"
   ],
   "orderby": 98,
   "required": true,
   "type": "date"
  },
  "/iati-organisations/iati-organisation/total-expenditure/value": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/total-expenditure",
    "/value"
   ],
   "orderby": 101,
   "required": true,
   "type": "number"
  },
  "/iati-organisations/iati-organisation/total-expenditure/value@currency": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/total-expenditure",
    "/value@currency"
   ],
   "orderby": 107,
   "type": "text"
  },
  "/iati-organisations/iati-organisation/total-expenditure/value@value-date": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "/total-expenditure",
    "/value@value-date"
   ],
   "orderby": 108,
   "type": "date"
  },
  "/iati-organisations/iati-organisation@default-currency": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "@default-currency"
   ],
   "orderby": 7,
   "type": "text"
  },
  "/iati-organisations/iati-organisation@iati-organisations:generated-datetime": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "@iati-organisations:generated-datetime"
   ],
   "orderby": 3,
   "type": "time"
  },
  "/iati-organisations/iati-organisation@iati-organisations:version": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "@iati-organisations:version"
   ],
   "orderby": 2,
   "required": true,
   "type": "text"
  },
  "/iati-organisations/iati-organisation@last-updated-datetime": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "@last-updated-datetime"
   ],
   "orderby": 5,
   "type": "time"
  },
  "/iati-organisations/iati-organisation@xml:lang": {
   "jpath": [
    "/iati-organisations/iati-organisation",
    "@xml:lang"
   ],
   "orderby": 123,
   "type": "text"
  },
  "/iati-organisations@generated-datetime": {
   "jpath": [
    "/iati-organisations@generated-datetime"
   ],
   "orderby": 3,
   "type": "time"
  },
  "/iati-organisations@version": {
   "jpath": [
    "/iati-organisations@version"
   ],
   "orderby": 2,
   "required": true,
   "type": "text"
  }
 },
 "tree": {
  "/iati-activities/iati-activity": [
   {
    "/activity-date": [
     {
      "/narrative": [
       {
        "": "text",
        "@xml:lang": "text"
       }
      ],
      "@iso-date": "1970-01-01",
      "@type": "text"
     }
    ],
    "/activity-scope@code": "text",
    "/activity-status@code": "text",
    "/budget": [
     {
      "/period-end@iso-date": "1970-01-01",
      "/period-start@iso-date": "1970-01-01",
      "/value": 1.1,
      "/value@currency": "text",
      "/value@value-date": "1970-01-01",
      "@status": "text",
      "@type": "text"
     }
    ],
    "/capital-spend@percentage": 1.1,
    "/collaboration-type@code": "text",
    "/conditions/condition": [
     {
      "/narrative": [
       {
        "": "text",
        "@xml:lang": "text"
       }
      ],
      "@type": "text"
     }
    ],
    "/conditions@attached": 0,
    "/contact-info": [
     {
      "/department/narrative": [
       {
        "": "text",
        "@xml:lang": "text"
       }
      ],
      "/email": [
       {
        "": "text"
       }
      ],
      "/job-title/narrative": [
       {
        "": "text",
        "@xml:lang": "text"
       }
      ],
      "/mailing-address": [
       {
        "/narrative": [
         {
          "": "text",
          "@xml:lang": "text"
         }
        ]
       }
      ],
      "/organisation/narrative": [
       {
        "": "text",
        "@xml:lang": "text"
       }
      ],
      "/person-name/narrative": [
       {
        "": "text",
        "@xml:lang": "text"
       }
      ],
      "/telephone": [
       {
        "": "text"
       }
      ],
      "/website": [
       {
        "": "text"
       }
      ],
      "@type": "text"
     }
    ],
    "/country-budget-items/budget-item": [
     {
      "/description/narrative": [
       {
        "": "text",
        "@xml:lang": "text"
       }
      ],
      "@code": "text",
      "@percentage": 1.1
     }
    ],
    "/country-budget-items@vocabulary": "text",
    "/crs-add/channel-code": "text",
    "/crs-add/loan-status/interest-arrears": 1.1,
    "/crs-add/loan-status/interest-received": 1.1,
    "/crs-add/loan-status/principal-arrears": 1.1,
    "/crs-add/loan-status/principal-outstanding": 1.1,
    "/crs-add/loan-status@currency": "text",
    "/crs-add/loan-status@value-date": "1970-01-01",
    "/crs-add/loan-status@year": 1.1,
    "/crs-add/loan-terms/commitment-date@iso-date": "1970-01-01",
    "/crs-add/loan-terms/repayment-final-date@iso-date": "1970-01-01",
    "/crs-add/loan-terms/repayment-first-date@iso-date": "1970-01-01",
    "/crs-add/loan-terms/repayment-plan@code": "text",
    "/crs-add/loan-terms/repayment-type@code": "text",
    "/crs-add/loan-terms@rate-1": 1.1,
    "/crs-add/loan-terms@rate-2": 1.1,
    "/crs-add/other-flags": [
     {
      "@code": "text",
      "@significance": 0
     }
    ],
    "/default-aid-type": [
     {
      "@code": "text",
      "@vocabulary": "text"
     }
    ],
    "/default-finance-type@code": "text",
    "/default-flow-type@code": "text",
    "/default-tied-status@code": "text",
    "/description": [
     {
      "/narrative": [
       {
        "": "text",
        "@xml:lang": "text"
       }
      ],
      "@type": "text"
     }
    ],
    "/document-link": [
     {
      "/category": [
       {
        "@code": "text"
       }
      ],
      "/description/narrative": [
       {
        "": "text",
        "@xml:lang": "text"
       }
      ],
      "/document-date@iso-date": "1970-01-01",
      "/language": [
       {
        "@code": "text"
       }
      ],
      "/title/narrative": [
       {
        "": "text",
        "@xml:lang": "text"
       }
      ],
      "@format": "text",
      "@url": "text"
     }
    ],
    "/fss/forecast": [
     {
      "": 1.1,
      "@currency": "text",
      "@value-date": "1970-01-01",
      "@year": 1.1
     }
    ],
    "/fss@extraction-date": "1970-01-01",
    "/fss@phaseout-year": 1.1,
    "/fss@priority": 0,
    "/humanitarian-scope": [
     {
      "/narrative": [
       {
        "": "text",
        "@xml:lang": "text"
       }
      ],
      "@code": "text",
      "@type": "text",
      "@vocabulary": "text",
      "@vocabulary-uri": "text"
     }
    ],
    "/iati-identifier": "text",
    "/legacy-data": [
     {
      "@iati-equivalent": "text",
      "@name": "text",
      "@value": "text"
     }
    ],
    "/location": [
     {
      "/activity-description/narrative": [
       {
        "": "text",
        "@xml:lang": "text"
       }
      ],
      "/administrative": [
       {
        "@code": "text",
        "@level": 1,
        "@vocabulary": "text"
       }
      ],
      "/description/narrative": [
       {
        "": "text",
        "@xml:lang": "text"
       }
      ],
      "/exactness@code": "text",
      "/feature-designation@code": "text",
      "/location-class@code": "text",
      "/location-id": [
       {
        "@code": "text",
        "@vocabulary": "text"
       }
      ],
      "/location-reach@code": "text",
      "/name/narrative": [
       {
        "": "text",
        "@xml:lang": "text"
       }
      ],
      "/point/pos": "text",
      "/point@srsName": "text",
      "@ref": "text"
     }
    ],
    "/other-identifier": [
     {
      "/owner-org/narrative": [
       {
        "": "text",
        "@xml:lang": "text"
       }
      ],
      "/owner-org@ref": "text",
      "@ref": "text",
      "@type": "text"
     }
    ],
    "/participating-org": [
     {
      "/narrative": [
       {
        "": "text",
        "@xml:lang": "text"
       }
      ],
      "@activity-id": "text",
      "@crs-channel-code": "text",
      "@ref": "text",
      "@role": "text",
      "@type": "text"
     }
    ],
    "/planned-disbursement": [
     {
      "/period-end@iso-date": "1970-01-01",
      "/period-start@iso-date": "1970-01-01",
      "/provider-org/narrative": [
       {
        "": "text",
        "@xml:lang": "text"
       }
      ],
      "/provider-org@provider-activity-id": "text",
      "/provider-org@ref": "text",
      "/provider-org@type": "text",
      "/receiver-org/narrative": [
       {
        "": "text",
        "@xml:lang": "text"
       }
      ],
      "/receiver-org@receiver-activity-id": "text",
      "/receiver-org@ref": "text",
      "/receiver-org@type": "text",
      "/value": 1.1,
      "/value@currency": "text",
      "/value@value-date": "1970-01-01",
      "@type": "text"
     }
    ],
    "/policy-marker": [
     {
      "/narrative": [
       {
        "": "text",
        "@xml:lang": "text"
       }
      ],
      "@code": "text",
      "@significance": "text",
      "@vocabulary": "text",
      "@vocabulary-uri": "text"
     }
    ],
    "/recipient-country": [
     {
      "/narrative": [
       {
        "": "text",
        "@xml:lang": "text"
       }
      ],
      "@code": "text",
      "@percentage": 1.1
     }
    ],
    "/recipient-region": [
     {
      "/narrative": [
       {
        "": "text",
        "@xml:lang": "text"
       }
      ],
      "@code": "text",
      "@percentage": 1.1,
      "@vocabulary": "text",
      "@vocabulary-uri": "text"
     }
    ],
    "/related-activity": [
     {
      "@ref": "text",
      "@type": "text"
     }
    ],
    "/reporting-org/narrative": [
     {
      "": "text",
      "@xml:lang": "text"
     }
    ],
    "/reporting-org@ref": "text",
    "/reporting-org@secondary-reporter": 0,
    "/reporting-org@type": "text",
    "/result": [
     {
      "/description/narrative": [
       {
        "": "text",
        "@xml:lang": "text"
       }
      ],
      "/document-link": [
       {
        "/category": [
         {
          "@code": "text"
         }
        ],
        "/description/narrative": [
         {
          "": "text",
          "@xml:lang": "text"
         }
        ],
        "/document-date@iso-date": "1970-01-01",
        "/language": [
         {
          "@code": "text"
         }
        ],
        "/title/narrative": [
         {
          "": "text",
          "@xml:lang": "text"
         }
        ],
        "@format": "text",
        "@url": "text"
       }
      ],
      "/indicator": [
       {
        "/baseline": [
         {
          "/comment/narrative": [
           {
            "": "text",
            "@xml:lang": "text"
           }
          ],
          "/dimension": [
           {
            "@name": "text",
            "@value": "text"
           }
          ],
          "/document-link": [
           {
            "/category": [
             {
              "@code": "text"
             }
            ],
            "/description/narrative": [
             {
              "": "text",
              "@xml:lang": "text"
             }
            ],
            "/document-date@iso-date": "1970-01-01",
            "/language": [
             {
              "@code": "text"
             }
            ],
            "/title/narrative": [
             {
              "": "text",
              "@xml:lang": "text"
             }
            ],
            "@format": "text",
            "@url": "text"
           }
          ],
          "/location": [
           {
            "@ref": "text"
           }
          ],
          "@iso-date": "1970-01-01",
          "@value": "text",
          "@year": 1
         }
        ],
        "/description/narrative": [
         {
          "": "text",
          "@xml:lang": "text"
         }
        ],
        "/document-link": [
         {
          "/category": [
           {
            "@code": "text"
           }
          ],
          "/description/narrative": [
           {
            "": "text",
            "@xml:lang": "text"
           }
          ],
          "/document-date@iso-date": "1970-01-01",
          "/language": [
           {
            "@code": "text"
           }
          ],
          "/title/narrative": [
           {
            "": "text",
            "@xml:lang": "text"
           }
          ],
          "@format": "text",
          "@url": "text"
         }
        ],
        "/period": [
         {
          "/actual": [
           {
            "/comment/narrative": [
             {
              "": "text",
              "@xml:lang": "text"
             }
            ],
            "/dimension": [
             {
              "@name": "text",
              "@value": "text"
             }
            ],
            "/document-link": [
             {
              "/category": [
               {
                "@code": "text"
               }
              ],
              "/description/narrative": [
               {
                "": "text",
                "@xml:lang": "text"
               }
              ],
              "/document-date@iso-date": "1970-01-01",
              "/language": [
               {
                "@code": "text"
               }
              ],
              "/title/narrative": [
               {
                "": "text",
                "@xml:lang": "text"
               }
              ],
              "@format": "text",
              "@url": "text"
             }
            ],
            "/location": [
             {
              "@ref": "text"
             }
            ],
            "@value": "text"
           }
          ],
          "/period-end@iso-date": "1970-01-01",
          "/period-start@iso-date": "1970-01-01",
          "/target": [
           {
            "/comment/narrative": [
             {
              "": "text",
              "@xml:lang": "text"
             }
            ],
            "/dimension": [
             {
              "@name": "text",
              "@value": "text"
             }
            ],
            "/document-link": [
             {
              "/category": [
               {
                "@code": "text"
               }
              ],
              "/description/narrative": [
               {
                "": "text",
                "@xml:lang": "text"
               }
              ],
              "/document-date@iso-date": "1970-01-01",
              "/language": [
               {
                "@code": "text"
               }
              ],
              "/title/narrative": [
               {
                "": "text",
                "@xml:lang": "text"
               }
              ],
              "@format": "text",
              "@url": "text"
             }
            ],
            "/location": [
             {
              "@ref": "text"
             }
            ],
            "@value": "text"
           }
          ]
         }
        ],
        "/reference": [
         {
          "@code": "text",
          "@indicator-uri": "text",
          "@vocabulary": "text"
         }
        ],
        "/title/narrative": [
         {
          "": "text",
          "@xml:lang": "text"
         }
        ],
        "@aggregation-status": 0,
        "@ascending": 0,
        "@measure": "text"
       }
      ],
      "/reference": [
       {
        "@code": "text",
        "@vocabulary": "text",
        "@vocabulary-uri": "text"
       }
      ],
      "/title/narrative": [
       {
        "": "text",
        "@xml:lang": "text"
       }
      ],
      "@aggregation-status": 0,
      "@type": "text"
     }
    ],
    "/sector": [
     {
      "/narrative": [
       {
        "": "text",
        "@xml:lang": "text"
       }
      ],
      "@code": "text",
      "@percentage": 1.1,
      "@vocabulary": "text",
      "@vocabulary-uri": "text"
     }
    ],
    "/tag": [
     {
      "/narrative": [
       {
        "": "text",
        "@xml:lang": "text"
       }
      ],
      "@code": "text",
      "@vocabulary": "text",
      "@vocabulary-uri": "text"
     }
    ],
    "/title/narrative": [
     {
      "": "text",
      "@xml:lang": "text"
     }
    ],
    "/transaction": [
     {
      "/aid-type": [
       {
        "@code": "text",
        "@vocabulary": "text"
       }
      ],
      "/description/narrative": [
       {
        "": "text",
        "@xml:lang": "text"
       }
      ],
      "/disbursement-channel@code": "text",
      "/finance-type@code": "text",
      "/flow-type@code": "text",
      "/provider-org/narrative": [
       {
        "": "text",
        "@xml:lang": "text"
       }
      ],
      "/provider-org@provider-activity-id": "text",
      "/provider-org@ref": "text",
      "/provider-org@type": "text",
      "/receiver-org/narrative": [
       {
        "": "text",
        "@xml:lang": "text"
       }
      ],
      "/receiver-org@receiver-activity-id": "text",
      "/receiver-org@ref": "text",
      "/receiver-org@type": "text",
      "/recipient-country/narrative": [
       {
        "": "text",
        "@xml:lang": "text"
       }
      ],
      "/recipient-country@code": "text",
      "/recipient-region/narrative": [
       {
        "": "text",
        "@xml:lang": "text"
       }
      ],
      "/recipient-region@code": "text",
      "/recipient-region@vocabulary": "text",
      "/recipient-region@vocabulary-uri": "text",
      "/sector": [
       {
        "/narrative": [
         {
          "": "text",
          "@xml:lang": "text"
         }
        ],
        "@code": "text",
        "@vocabulary": "text",
        "@vocabulary-uri": "text"
       }
      ],
      "/tied-status@code": "text",
      "/transaction-date@iso-date": "1970-01-01",
      "/transaction-type@code": "text",
      "/value": 1.1,
      "/value@currency": "text",
      "/value@value-date": "1970-01-01",
      "@humanitarian": 0,
      "@ref": "text"
     }
    ],
    "@budget-not-provided": "text",
    "@default-currency": "text",
    "@hierarchy": -1,
    "@humanitarian": 0,
    "@iati-activities:generated-datetime": "1970-01-01T00:00:00",
    "@iati-activities:linked-data-default": "text",
    "@iati-activities:version": "text",
    "@last-updated-datetime": "1970-01-01T00:00:00",
    "@linked-data-uri": "text",
    "@xml:lang": "text"
   }
  ],
  "/iati-activities@generated-datetime": "1970-01-01T00:00:00",
  "/iati-activities@linked-data-default": "text",
  "/iati-activities@version": "text",
  "/iati-organisations/iati-organisation": [
   {
    "/document-link": [
     {
      "/category": [
       {
        "@code": "text"
       }
      ],
      "/description/narrative": [
       {
        "": "text",
        "@xml:lang": "text"
       }
      ],
      "/document-date@iso-date": "1970-01-01",
      "/language": [
       {
        "@code": "text"
       }
      ],
      "/recipient-country": [
       {
        "/narrative": [
         {
          "": "text",
          "@xml:lang": "text"
         }
        ],
        "@code": "text"
       }
      ],
      "/title/narrative": [
       {
        "": "text",
        "@xml:lang": "text"
       }
      ],
      "@format": "text",
      "@url": "text"
     }
    ],
    "/name/narrative": [
     {
      "": "text",
      "@xml:lang": "text"
     }
    ],
    "/organisation-identifier": "text",
    "/recipient-country-budget": [
     {
      "/budget-line": [
       {
        "/narrative": [
         {
          "": "text",
          "@xml:lang": "text"
         }
        ],
        "/value": 1.1,
        "/value@currency": "text",
        "/value@value-date": "1970-01-01",
        "@ref": "text"
       }
      ],
      "/period-end@iso-date": "1970-01-01",
      "/period-start@iso-date": "1970-01-01",
      "/recipient-country/narrative": [
       {
        "": "text",
        "@xml:lang": "text"
       }
      ],
      "/recipient-country@code": "text",
      "/value": 1.1,
      "/value@currency": "text",
      "/value@value-date": "1970-01-01",
      "@status": "text"
     }
    ],
    "/recipient-org-budget": [
     {
      "/budget-line": [
       {
        "/narrative": [
         {
          "": "text",
          "@xml:lang": "text"
         }
        ],
        "/value": 1.1,
        "/value@currency": "text",
        "/value@value-date": "1970-01-01",
        "@ref": "text"
       }
      ],
      "/period-end@iso-date": "1970-01-01",
      "/period-start@iso-date": "1970-01-01",
      "/recipient-org/narrative": [
       {
        "": "text",
        "@xml:lang": "text"
       }
      ],
      "/recipient-org@ref": "text",
      "/value": 1.1,
      "/value@currency": "text",
      "/value@value-date": "1970-01-01",
      "@status": "text"
     }
    ],
    "/recipient-region-budget": [
     {
      "/budget-line": [
       {
        "/narrative": [
         {
          "": "text",
          "@xml:lang": "text"
         }
        ],
        "/value": 1.1,
        "/value@currency": "text",
        "/value@value-date": "1970-01-01",
        "@ref": "text"
       }
      ],
      "/period-end@iso-date": "1970-01-01",
      "/period-start@iso-date": "1970-01-01",
      "/recipient-region/narrative": [
       {
        "": "text",
        "@xml:lang": "text"
       }
      ],
      "/recipient-region@code": "text",
      "/recipient-region@vocabulary": "text",
      "/recipient-region@vocabulary-uri": "text",
      "/value": 1.1,
      "/value@currency": "text",
      "/value@value-date": "1970-01-01",
      "@status": "text"
     }
    ],
    "/reporting-org/narrative": [
     {
      "": "text",
      "@xml:lang": "text"
     }
    ],
    "/reporting-org@ref": "text",
    "/reporting-org@secondary-reporter": 0,
    "/reporting-org@type": "text",
    "/total-budget": [
     {
      "/budget-line": [
       {
        "/narrative": [
         {
          "": "text",
          "@xml:lang": "text"
         }
        ],
        "/value": 1.1,
        "/value@currency": "text",
        "/value@value-date": "1970-01-01",
        "@ref": "text"
       }
      ],
      "/period-end@iso-date": "1970-01-01",
      "/period-start@iso-date": "1970-01-01",
      "/value": 1.1,
      "/value@currency": "text",
      "/value@value-date": "1970-01-01",
      "@status": "text"
     }
    ],
    "/total-expenditure": [
     {
      "/expense-line": [
       {
        "/narrative": [
         {
          "": "text",
          "@xml:lang": "text"
         }
        ],
        "/value": 1.1,
        "/value@currency": "text",
        "/value@value-date": "1970-01-01",
        "@ref": "text"
       }
      ],
      "/period-end@iso-date": "1970-01-01",
      "/period-start@iso-date": "1970-01-01",
      "/value": 1.1,
      "/value@currency": "text",
      "/value@value-date": "1970-01-01"
     }
    ],
    "@default-currency": "text",
    "@iati-organisations:generated-datetime": "1970-01-01T00:00:00",
    "@iati-organisations:version": "text",
    "@last-updated-datetime": "1970-01-01T00:00:00",
    "@xml:lang": "text"
   }
  ],
  "/iati-organisations@generated-datetime": "1970-01-01T00:00:00",
  "/iati-organisations@version": "text"
 }
}